import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import level1 from './images/level1.svg'
import level2 from './images/level2.svg'
import level3 from './images/level3.svg'
import level4 from './images/level4.svg'
import level1BlackTag from './images/level1-black-tag.svg'
import level2BlackTag from './images/level2-black-tag.svg'
import level3BlackTag from './images/level3-black-tag.svg'
import level4BlackTag from './images/level4-black-tag.svg'

import './LevelTag.scss'

const DEFAULT_LEVEL_ICONS = {
  1: level1,
  2: level2,
  3: level3,
  4: level4,
}

const BLACK_TAG_LEVEL_ICONS = {
  1: level1BlackTag,
  2: level2BlackTag,
  3: level3BlackTag,
  4: level4BlackTag,
}

export const LevelTag = ({
  level = '',
  variant = 'default',
  technology = '',
}) => {
  const { t } = useTranslation()
  const classes = classnames('c-level-tag', `c-level-tag__${variant}`)

  if (!level) return null

  const levelIcons =
    variant === 'black' ? BLACK_TAG_LEVEL_ICONS : DEFAULT_LEVEL_ICONS
  const levelIcon = levelIcons[level]
  const levelText = t(`general.level-tag.${level}`, { defaultValue: '' })
  const levelTechnology = t(`general.technology-themes.${technology}`, {
    defaultValue: '',
  })

  return (
    <div className={classes}>
      <img className="c-level-tag__icon" src={levelIcon} alt="" />

      <span className="c-level-tag__text">
        {levelTechnology && <span>{levelTechnology} - </span>}
        {levelText && <span>{levelText}</span>}
      </span>
    </div>
  )
}

LevelTag.propTypes = {
  className: PropTypes.string,
  level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  technology: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'black']),
}

export default LevelTag
